import React from "react";
import { Tooltip } from "@mui/material";

import { Button } from "components/ui/Button/Button";
import { PCRS_CONNECTION_REQUIRED_MESSAGE } from "features/cdm/constants/pcrsSchemeCheck";

import styles from "./CdmHeaderActions.module.css";

// The CDM header action buttons (Start review / View PCRS details / Deregister)
// with their PCRS gating + tooltips. Rendered into CdmHeaderBar's `actions` slot.
export const CdmHeaderActions = ({
  hasProgrammeOptions,
  areReviewActionsDisabled,
  isPatientValid,
  isEnrolled,
  onStartReview,
  onViewPcrsDetails,
  onDeregister,
}) => {
  const disabledTooltip = areReviewActionsDisabled
    ? PCRS_CONNECTION_REQUIRED_MESSAGE
    : "";

  return (
    <>
      {/* Order (left → right): View PCRS details, Deregister, Start review — the
          primary "Start review" stays the rightmost call-to-action, and the
          destructive Deregister sits in the middle rather than on the edge. */}
      <Button
        variant="outline"
        disabled={!isPatientValid}
        onClick={onViewPcrsDetails}
      >
        View PCRS details
      </Button>
      {isEnrolled && (
        <Tooltip title={disabledTooltip}>
          <span className={styles.deregisterAction}>
            <Button
              variant="outline"
              className={styles.deregisterButton}
              disabled={areReviewActionsDisabled}
              onClick={onDeregister}
            >
              Deregister patient
            </Button>
          </span>
        </Tooltip>
      )}
      {hasProgrammeOptions && (
        <Tooltip title={disabledTooltip}>
          <span>
            <Button
              variant="primary"
              disabled={areReviewActionsDisabled}
              onClick={onStartReview}
            >
              Start review
            </Button>
          </span>
        </Tooltip>
      )}
    </>
  );
};
